import { Modal } from "react-bootstrap";
import "./educationalcenter.scss";
import { inject, observer } from "mobx-react";
import { sendMetriks } from "utils/metriks";
import moment from "moment";

import { useEffect, useState } from "react";
import cross from "images/cross.svg";
import topArrow from "images/topArrow.svg";
import downArrow from "images/downArrow.svg";
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ru from "date-fns/locale/ru";
registerLocale("ru", ru);

const EducationalCenter = ({
  setEducationalCenterModal,
  candidates,
  sendCandidateOnVacancy,
  applications,
  refreshCandidateOnVacancy,
  events,
  education_centers,
  positionId,
  vacancyId,
  setOpenList,
  setSuccessModal,
  ...props
}) => {
  const [blockedBtn, setBlockedBtn] = useState(false);

  const selectedDate = [];
  const allDates = {};
  events[positionId] &&
    Object.entries(events[positionId]).map((center) => {
      const id = center[0];
      allDates[id] = [];
      Object.entries(center[1]).map((item) => {
        const date = item[0];
        allDates[id].push(
          new Date(moment(date, "DD.MM.YYYY").format("YYYY/MM/DD"))
        );
      });
    });

  useEffect(() => {
    for (let i = 0; i < candidates?.length; ++i) {
      candidates[i]["openCenters"] = false;
    }
    for (let i = 0; i < candidates?.length; ++i) {
      candidates[i]["centerId"] = false;
    }
    for (let i = 0; i < candidates?.length; ++i) {
      candidates[i]["center"] = false;
    }
    for (let i = 0; i < candidates?.length; ++i) {
      candidates[i]["arrival_date"] = false;
    }
  }, []);

  const checkData = () => {
    let isBlocked = false;
    for (let i = 0; i < candidates?.length; ++i) {
      if (candidates[i]["checked"] == undefined) {
        continue;
      }
      if (candidates[i]["arrival_date"] != false) {
        isBlocked = true;
      } else {
        isBlocked = false;
      }
    }
    setBlockedBtn(isBlocked);
  };
  const send = () => {
    setOpenList(false);
    for (let i = 0; i < candidates?.length; ++i) {
      let application = false;
      if (
        candidates[i]["checked"] == undefined &&
        candidates[i]["arrival_date"] == undefined
      ) {
        continue;
      }
      if (applications === "-1") {
        continue;
      }
      for (let j = 0; j < applications?.length; j++) {
        if (applications[j]["candidate_id"] === candidates[i]["id"]) {
          if (
            applications[j]["status_id"] ==
              "f1f5364f32642699346e0c1b4bc83dab42008f9e" ||
            applications[j]["date_arrival"] === null
          ) {
            refreshCandidateOnVacancy({
              vacancy_candidate_id: applications[j]["vacancy_candidate_id"],
              date_arrival: moment(
                candidates[i]["arrival_date"],
                "llll"
              ).format("YYYY-MM-DD"),
              education_center_id: candidates[i]["centerId"]
            });
            application = true;
          } else {
            sendCandidateOnVacancy({
              candidate_id: candidates[i]["id"],
              vacancy_id: vacancyId,
              date_arrival: moment(
                candidates[i]["arrival_date"],
                "llll"
              ).format("YYYY-MM-DD"),
              education_center_id: candidates[i]["centerId"]
            });
            application = true;
          }
        }
      }
      if (!application) {
        sendCandidateOnVacancy({
          candidate_id: candidates[i]["id"],
          vacancy_id: vacancyId,
          date_arrival: moment(candidates[i]["arrival_date"], "llll").format(
            "YYYY-MM-DD"
          ),
          education_center_id: candidates[i]["centerId"]
        });
        application = false;
      }
    }
    setSuccessModal(true);
    for (let i = 0; i < candidates?.length; ++i) {
      candidates[i]["checked"] = false;
    }
    setEducationalCenterModal(false);
  };

  return (
    <Modal
      show={props.show}
      onHide={props.onHide}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
    >
      <Modal.Body className="educational-modal">
        <div className="educational-modal-top">
          <div className="educational-modal__title">
            <p className="educational-modal__title-text">
              Выберите учебный центр и дату прибытия
            </p>
            <img
              src={cross}
              className="educational-modal__title-cross"
              onClick={props.onHide}
              alt=""
            />
          </div>
          <div className="educational-modal__main">
            {candidates?.length > 0 ? (
              <>
                {candidates.map((candidate, i) => {
                  if (candidate["checked"] === true) {
                    return (
                      <div
                        className="educational-modal__main-string"
                        key={candidate.id}
                      >
                        <div className="educational-modal__main-name">
                          {candidate.surname} {candidate.name}{" "}
                          {candidate.patronymic}
                        </div>
                        {events[positionId] ? (
                          <div className="educational-modal__main-cols">
                            <div className="educational-modal__main-selections">
                              <div className="educational-modal__main-selections-one">
                                {candidates[i]["openCenters"] ? (
                                  <>
                                    <div
                                      className="educational-modal__main-selections-lable"
                                      onClick={() =>
                                        (candidates[i]["openCenters"] = false)
                                      }
                                    >
                                      {candidates[i]["center"] ? (
                                        <p className="educational-modal__main-selections-lable-blacktext">
                                          {candidates[i]["center"]}
                                        </p>
                                      ) : (
                                        <p className="educational-modal__main-selections-lable-text">
                                          Учебный центр
                                        </p>
                                      )}

                                      <img
                                        src={topArrow}
                                        className="educational-modal__main-selections-lable-arrow"
                                        alt=""
                                      />
                                    </div>
                                    <div className="multiselect">
                                      <div className="educational-modal__main-checkboxes">
                                        {Object.entries(events[positionId]).map(
                                          (center) => {
                                            return (
                                              <label
                                                key={
                                                  education_centers[center[0]][
                                                    "id"
                                                  ]
                                                }
                                                htmlFor={
                                                  education_centers[center[0]][
                                                    "id"
                                                  ]
                                                }
                                                className="educational-modal__main-checkboxes-item"
                                              >
                                                <input
                                                  type="radio"
                                                  value={
                                                    education_centers[
                                                      center[0]
                                                    ]["id"]
                                                  }
                                                  id={
                                                    education_centers[
                                                      center[0]
                                                    ]["id"]
                                                  }
                                                  name="centers"
                                                  onChange={() => {
                                                    candidates[i]["center"] =
                                                      education_centers[
                                                        center[0]
                                                      ]["title"];
                                                    candidates[i]["centerId"] =
                                                      education_centers[
                                                        center[0]
                                                      ]["id"];
                                                    candidates[i][
                                                      "openCenters"
                                                    ] = false;
                                                    candidates[i][
                                                      "arrival_date"
                                                    ] = false;
                                                  }}
                                                />
                                                г.{" "}
                                                {
                                                  education_centers[center[0]][
                                                    "title"
                                                  ]
                                                }
                                              </label>
                                            );
                                          }
                                        )}
                                      </div>
                                    </div>
                                  </>
                                ) : (
                                  <div
                                    className="educational-modal__main-selections-lable"
                                    onClick={() => {
                                      for (
                                        let i = 0;
                                        i < candidates?.length;
                                        ++i
                                      ) {
                                        if (candidates[i]["openCenters"]) {
                                          candidates[i]["openCenters"] = false;
                                        }
                                      }
                                      candidates[i]["openCenters"] = true;
                                    }}
                                  >
                                    {candidates[i]["center"] ? (
                                      <p className="educational-modal__main-selections-lable-blacktext">
                                        г. {candidates[i]["center"]}
                                      </p>
                                    ) : (
                                      <p className="educational-modal__main-selections-lable-text">
                                        Учебный центр
                                      </p>
                                    )}

                                    <img
                                      src={downArrow}
                                      className="educational-modal__main-selections-lable-arrow"
                                      alt=""
                                    />
                                  </div>
                                )}
                                {/* <div className="educational-modal__main-selections-list"></div> */}
                              </div>
                            </div>

                            {candidates[i]["centerId"] ? (
                              <>
                                {Object.entries(allDates).map((center) => {
                                  return candidates[i]["centerId"] ===
                                    center[0] ? (
                                    <>
                                      <DatePicker
                                        className={`${
                                          candidates[i]["arrival_date"]
                                            ? "educational-modal__main-blackcalendar"
                                            : "educational-modal__main-calendar"
                                        }`}
                                        value={
                                          candidates[i]["arrival_date"]
                                            ? moment(
                                                candidates[i]["arrival_date"]
                                              ).format("L")
                                            : ""
                                        }
                                        selected={
                                          candidates[i]["arrival_date"]
                                            ? candidates[i]["arrival_date"]
                                            : ""
                                        }
                                        locale="ru"
                                        onChange={(date) => {
                                          candidates[i]["arrival_date"] = date;
                                          checkData();
                                        }}
                                        includeDates={center[1]}
                                        placeholderText="Дата прибытия"
                                        onCalendarOpen={() =>
                                          (candidates[i]["openCenters"] = false)
                                        }
                                        disabledKeyboardNavigation
                                      />
                                    </>
                                  ) : (
                                    ""
                                  );
                                })}
                              </>
                            ) : (
                              <DatePicker
                                className="educational-modal__main-calendar"
                                locale="ru"
                                includeDates={selectedDate}
                                placeholderText="Дата прибытия"
                                disabled
                              />
                            )}
                          </div>
                        ) : (
                          <p className="applications-small__card-text-value">
                            Событие не назначено. Пожалуйста, обратитесь к
                            Вашему менеджеру за обновлением расписания.
                          </p>
                        )}
                      </div>
                    );
                  }
                })}
              </>
            ) : (
              ""
            )}
          </div>
        </div>
        <button
          type="submit"
          className="educational-modal__btn"
          disabled={!blockedBtn}
          onClick={() => {
            send();
            sendMetriks("reachGoal", "resp_5");
          }}
        >
          Откликнуться
        </button>
      </Modal.Body>
    </Modal>
  );
};

export default inject(({ usersStore, vacanciesStore, candidatesStore }) => {
  const { error, isLoading } = usersStore;

  const {
    education_centers,
    applications,
    refreshCandidateOnVacancy,

    sendCandidateOnVacancy
  } = candidatesStore;
  const { vacancies, events } = vacanciesStore;
  return {
    vacancies,
    events,
    education_centers,
    sendCandidateOnVacancy,
    refreshCandidateOnVacancy,
    applications,
    error,
    isLoading
  };
})(observer(EducationalCenter));
